import type { SVGProps } from "react";
const SvgArrowDown02Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M10 15.833v-12.5M5.833 12.5l3.578 3.577c.277.278.416.417.589.417.172 0 .311-.139.59-.417l3.577-3.577"
    />
  </svg>
);
export default SvgArrowDown02Sharp;
